import axiosInstance, { getApiErrorMessage } from "../auth/apiConfig";

const WEB_BASE = "/api/v1/web/purchase-orders";

export const mapLookupToOption = (item) => ({
  id: item.id,
  value: item.id,
  label: item.name || `Item ${item.id}`,
});

export const mapFiltersToApiParams = (filters = {}) => {
  const storeId = Number(filters.toStore?.value ?? filters.toStore?.id ?? 0);
  const supplierId = Number(filters.supplier?.value ?? filters.supplier?.id ?? 0);
  return {
    storeId: storeId > 0 ? storeId : undefined,
    supplierId: supplierId > 0 ? supplierId : undefined,
    fromDate: filters.fromDate || undefined,
    toDate: filters.toDate || undefined,
    cancelled: filters.cancelledPo ? 1 : 0,
  };
};

export const mapListItemToUi = (row) => ({
  poId: row.purchaseId,
  purchaseId: row.purchaseId,
  purNo: row.purchaseNo || String(row.purchaseId || ""),
  date: row.date || "",
  storeId: row.storeId,
  toStore: row.storeName || "",
  supplierId: row.supplierId,
  supplierName: row.supplierName || "",
  totalAmt: Number(row.totalAmt || 0),
  discAmt: Number(row.discAmt || 0),
  gstAmt: Number(row.gstAmt || 0),
  netAmt: Number(row.netAmt || 0),
  verify: row.verify || "Pending",
  cancelled: Boolean(row.cancelled),
  items: [],
});

export const mapDetailToUi = (detail) => {
  const header = mapListItemToUi(detail?.header || {});
  return {
    ...header,
    items: (detail?.items || []).map((item) => ({
      itemId: item.itemId,
      purDetId: item.purDetId,
      itemName: item.itemName || "",
      qty: Number(item.qty || 0),
      rate: Number(item.rate || 0),
      gstPer: Number(item.gstPer || 0),
      gstAmt: Number(item.gstAmt || 0),
      discPer: Number(item.discPer || 0),
      discAmt: Number(item.discAmt || 0),
      totalAmt: Number(item.totalAmt || 0),
    })),
  };
};

export const mapItemsToSavePayload = (items, userId) => ({
  userId: Number(userId || 1),
  items: (items || []).map((item) => ({
    purDetId: Number(item.purDetId || 0),
    qty: Number(item.qty || 0),
  })),
});

export const listStores = async () => {
  try {
    const response = await axiosInstance.get(`${WEB_BASE}/stores`);
    return (response.data?.data ?? []).map(mapLookupToOption);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load stores"));
  }
};

export const listSuppliers = async (query) => {
  try {
    const response = await axiosInstance.get(`${WEB_BASE}/suppliers`, {
      params: { q: query?.trim() || undefined },
    });
    return (response.data?.data ?? []).map(mapLookupToOption);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load suppliers"));
  }
};

export const listPurchaseOrders = async (filters = {}) => {
  try {
    const response = await axiosInstance.get(WEB_BASE, {
      params: mapFiltersToApiParams(filters),
    });
    return (response.data?.data ?? []).map(mapListItemToUi);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load purchase orders"));
  }
};

export const getPurchaseOrderById = async (purchaseId) => {
  try {
    const response = await axiosInstance.get(`${WEB_BASE}/${purchaseId}`);
    return mapDetailToUi(response.data?.data);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to load purchase order"));
  }
};

export const savePurchaseOrder = async (purchaseId, items, userId) => {
  try {
    const response = await axiosInstance.put(
      `${WEB_BASE}/${purchaseId}`,
      mapItemsToSavePayload(items, userId)
    );
    return response.data?.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to save purchase order"));
  }
};

export const approvePurchaseOrder = async (purchaseId, items, userId) => {
  try {
    const response = await axiosInstance.post(
      `${WEB_BASE}/${purchaseId}/approve`,
      mapItemsToSavePayload(items, userId)
    );
    return response.data?.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, "Failed to approve purchase order"));
  }
};
